import { useMemo, useRef, type ReactElement, type ReactNode } from "react";
import type { ArchitectureViewHandle } from "../architecture-view/ArchitectureView.js";
import { createHoverStore, type HoverStore } from "../board/hoverStore.js";
import { BoardHandleContext, type BoardHandle } from "./BoardHandleContext.js";

/**
 * BoardHandleProvider — owns the composition's board transport (the imperative
 * `boardRef` handle + the shared board↔nav `hoverStore`). Both are created once
 * and stable for the mount, so consumers can read them from context rather than
 * having the composition thread them down as props.
 */
export function BoardHandleProvider({
  children,
}: {
  readonly children: ReactNode;
}): ReactElement {
  const boardRef = useRef<ArchitectureViewHandle | null>(null);
  const hoverStoreRef = useRef<HoverStore | null>(null);
  if (hoverStoreRef.current === null) hoverStoreRef.current = createHoverStore();
  const value = useMemo<BoardHandle>(
    () => ({ boardRef, hoverStore: hoverStoreRef.current! }),
    [],
  );
  return (
    <BoardHandleContext.Provider value={value}>
      {children}
    </BoardHandleContext.Provider>
  );
}
